import { Block, Loader } from 'components/elements';
import { LanguageContext } from 'context';
import React, { Fragment, FunctionComponent, useContext, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { decodeHtml } from 'utils';

interface OwnProps {
  name: string;
  meta?: YoastMeta[];
  title?: string | null;
  loading?: boolean;
}

type PageWrapperProps = Omit<JSX.IntrinsicElements['article'], 'type' | 'meta' | 'title'> & OwnProps;

const PageWrapper: FunctionComponent<PageWrapperProps> = props => {
  const { meta = [], title = '', loading, children, name } = props;
  const { loading: globalLoading } = useContext(LanguageContext);
  const anyLoading = globalLoading || loading;

  const { pathname } = useLocation();

  // Add a class to the body based on the page name and pathname
  useLayoutEffect(() => {
    const pageClass = `page-${name}`;

    document.body.classList.add(pageClass);

    return () => {
      document.body.classList.remove(pageClass);
    };
  }, [name, pathname]);

  // Scroll to top on pathname change
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
      <Fragment>
        {/* @ts-ignore */}
        <Helmet defer={false} encodeSpecialCharacters={true}>
          <title>{decodeHtml(title || 'TestArmy')}</title>
          {meta.map(({ name, property, content }, index) => {
            return <meta key={`meta-${name || property}-${index}`} name={name || property} content={content} />;
          })}
        </Helmet>
        <div data-page={name} />
        {anyLoading && (
            <Block width="full" style={{ minHeight: '50vh' }} data-page={name}>
              <Loader loading={anyLoading} />
            </Block>
        )}
        {!anyLoading && children}
      </Fragment>
  );
};

export default PageWrapper;
